import { Badge, Modal } from "flowbite-react";
import { useContext } from "react";
import { IAppContextState, AppContext } from "../../../App";
import { Link } from "react-router-dom";
import { Agency1ImageGallery } from "../../../components/image-gallery/agency1-gallery";

export const Agency1ModalData = () => {
  const { agency1ModalState } = useContext<IAppContextState | any>(AppContext);
  const [isOpenAgency1Modal, setOpenAgency1Modal] = agency1ModalState;
  return (
    <Modal
      size={"5xl"}
      position={"top-center"}
      show={isOpenAgency1Modal}
      onClose={() => setOpenAgency1Modal(false)}
    >
      <Modal.Header>Agency Solutions</Modal.Header>
      <Modal.Body>
        <div className="flex flex-wrap">
          <div className="md:w-[50%] w-full pe-2">
            <Agency1ImageGallery />
          </div>
          <div className="md:w-[50%] w-full ps-2 md:mt-0 mt-6 flex flex-col justify-between">
            <div>
              <h3 className="font-bold text-xl">
                Project name:{" "}
                <span className="text-green-500">Agency Solutions</span>
              </h3>
              <p className="mt-4 mb-2 text-md text-[15px]">Tech used:</p>
              <div className="flex">
                <Badge color="red" className="me-2 my-1">
                  HTML
                </Badge>
                <Badge color="gray" className="me-2 my-1">
                  javaScript
                </Badge>
                <Badge color="yellow" className="me-2 my-1">
                  jQuery
                </Badge>
                <Badge color="blue" className="me-2 my-1">
                  Bootstrap
                </Badge>
                <Badge color="pink" className="my-1">
                  SCSS
                </Badge>
              </div>
              <div className="mt-5 mb-2 ">
                <p className="font-semibold">Description:</p>
                <div className="text-[15px]">
                  <p>
                    A clean and professional company landing page theme built to
                    highlight agency offerings and attract clients.
                  </p>
                  <ul className="list-disc ms-5 mt-4">
                    <li>
                      This website is made with HTML, Bootstrap, javaScript and
                      jQuery
                    </li>
                    <li>
                      This website features custom bootstrap theming with SCSS
                    </li>
                    <li>
                      A minimal eye-catching UI followed to engage more users
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="mt-10">
              <Link
                target="_blank"
                rel="noreferrer"
                to="https://agency-solutions.netlify.app/"
                className="text-pink-800 hover:text-pink-950 hover:underline"
              >
                Go to website
              </Link>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
